import MapIcon from "@material-ui/icons/Map";
import ProvinceList from "./ProvinceList";

export default {
  list: ProvinceList,
  icon: MapIcon,
};
